import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db, firebaseConfig } from "../../../../firebase";
import { initializeApp, deleteApp, getApps } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import UserForm from "../../../../Components/Form/UserForm";
import { showSuccessToast, showErrorToast } from "../../../../toastmsg";
import { deleteUser } from "firebase/auth";

const AddUser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddUser = async (formData: any) => {
    setLoading(true);

    if (!auth.currentUser) {
      showErrorToast("You must be logged in to add users");
      setLoading(false);
      return;
    }

    let secondaryApp;
    try {
      const existingApp = getApps().find((app) => app.name === "Secondary");
      secondaryApp = existingApp || initializeApp(firebaseConfig, "Secondary");
      const secondaryAuth = getAuth(secondaryApp);

      // Step 1: Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        secondaryAuth,
        formData.email,
        formData.password
      );

      const newUser = userCredential.user;

      // Step 2: Set display name
      await updateProfile(newUser, {
        displayName: formData.displayName,
        // displayName: formData.name,
      });

      // Step 3: Create user document in Firestore
      if (!auth.currentUser) {
        throw new Error("Authentication lost during user creation");
      }

      try {
        await setDoc(doc(db, "users", newUser.uid), {
          firstName: formData.firstName,
          lastName: formData.lastName,
          displayName: formData.displayName,
          email: formData.email,
          role: formData.role,
          branch: formData.branch || "", // ✅ Add branch field
          createdAt: serverTimestamp(),
        });
      } catch (firestoreError) {
        // ❗ Firestore write failed – delete the created user from Auth
        console.warn("Firestore write failed. Deleting Auth user...");
        try {
          await deleteUser(newUser);
          console.info("Cleaned up Auth user due to failed Firestore write.");
        } catch (deleteError) {
          console.error(
            "Failed to delete user from Firebase Auth:",
            deleteError
          );
          throw new Error(
            "User creation failed due to Firestore permission error. Manual cleanup may be required."
          );
        }
        throw firestoreError; // continue throwing the original error
      }

      showSuccessToast("User added successfully");

      setTimeout(() => {
        navigate("/user-listing", { state: { refresh: true } });
      }, 1500);
    } catch (error: any) {
      console.error("Error adding user:", error);

      let errorMessage = "Failed to add user";

      if (error.code === "auth/email-already-in-use") {
        errorMessage = "Email already in use. Try another.";
      } else if (
        error.code === "permission-denied" ||
        error.message?.includes("insufficient permissions")
      ) {
        errorMessage =
          "You don't have permission to create users. Please contact your administrator.";
      } else {
        errorMessage = error.message || "Failed to add user";
      }

      showErrorToast(errorMessage);
    } finally {
      if (secondaryApp) await deleteApp(secondaryApp);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/user-listing", { state: { refresh: true } });
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Add New User</h2>

      <UserForm
        onSubmit={handleAddUser}
        onCancel={handleCancel}
        disabled={loading}
      />
    </div>
  );
};

export default AddUser;
